"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Pointer = _interopRequireWildcard(require("./Pointer.js"));

var _functions = require("../functions.js");

var _rotationconstraint = require("../rotationconstraint.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/PinchRotate
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */

/**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */
var PinchRotate =
/** @class */
function (_super) {
  __extends(PinchRotate, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function PinchRotate(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var pointerOptions =
    /** @type {import("./Pointer.js").Options} */
    options;

    if (!pointerOptions.stopDown) {
      pointerOptions.stopDown = _functions.FALSE;
    }

    _this = _super.call(this, pointerOptions) || this;
    /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */

    _this.anchor_ = null;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.lastAngle_ = undefined;
    /**
     * @private
     * @type {boolean}
     */

    _this.rotating_ = false;
    /**
     * @private
     * @type {number}
     */

    _this.rotationDelta_ = 0.0;
    /**
     * @private
     * @type {number}
     */

    _this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 250;
    return _this;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  PinchRotate.prototype.handleDragEvent = function (mapBrowserEvent) {
    var rotationDelta = 0.0;
    var touch0 = this.targetPointers[0];
    var touch1 = this.targetPointers[1]; // angle between touches

    var angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);

    if (this.lastAngle_ !== undefined) {
      var delta = angle - this.lastAngle_;
      this.rotationDelta_ += delta;

      if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) {
        this.rotating_ = true;
      }

      rotationDelta = delta;
    }

    this.lastAngle_ = angle;
    var map = mapBrowserEvent.map;
    var view = map.getView();

    if (view.getConstraints().rotation === _rotationconstraint.disable) {
      return;
    } // rotate anchor point.
    // FIXME: should be the intersection point between the lines:
    //     touch0,touch1 and previousTouch0,previousTouch1


    var viewportPosition = map.getViewport().getBoundingClientRect();
    var centroid = (0, _Pointer.centroid)(this.targetPointers);
    centroid[0] -= viewportPosition.left;
    centroid[1] -= viewportPosition.top;
    this.anchor_ = map.getCoordinateFromPixelInternal(centroid); // rotate

    if (this.rotating_) {
      map.render();
      view.adjustRotationInternal(rotationDelta, this.anchor_);
    }
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  PinchRotate.prototype.handleUpEvent = function (mapBrowserEvent) {
    if (this.targetPointers.length < 2) {
      var map = mapBrowserEvent.map;
      var view = map.getView();
      view.endInteraction(this.duration_);
      return false;
    } else {
      return true;
    }
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  PinchRotate.prototype.handleDownEvent = function (mapBrowserEvent) {
    if (this.targetPointers.length >= 2) {
      var map = mapBrowserEvent.map;
      this.anchor_ = null;
      this.lastAngle_ = undefined;
      this.rotating_ = false;
      this.rotationDelta_ = 0.0;

      if (!this.handlingDownUpSequence) {
        map.getView().beginInteraction();
      }

      return true;
    } else {
      return false;
    }
  };

  return PinchRotate;
}(_Pointer["default"]);

var _default = PinchRotate;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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